export enum ESignSimulateType {
  CLOSED_WITHOUT_SIGNING = 'closedWithoutSigning',
  CLOSED_WITH_PARTIAL_SIGNING = 'closedWithPartialSigning',
  CLOSED_WITH_COMPLETE_SIGNING = 'closedWithCompleteSigning',
}
